import z from "zod";

const zPossiblyEmptyFeatureName = z
  .string()
  .trim()
  .max(2 ** 6);

const zFeatureSchema = z.object({
  id: z.string().uuid(),
  name: zPossiblyEmptyFeatureName.nonempty(),
  description: z
    .string()
    .trim()
    .max(2 ** 8),
});
type FeatureSchema = z.infer<typeof zFeatureSchema>;

export { zFeatureSchema, zPossiblyEmptyFeatureName };
export type { FeatureSchema };
